import { Modal, ModalTabs, PDFRenderer } from "components";
import { classNames, wrapClick } from "utils";

import { LocationGenerics } from "router/location";
import config from "config";
import { useInsurer } from "hooks/data/use-insurers";
import { useSearch } from "react-location";
import { useState } from "react";

const tabs: any[] = [
  {
    name: "Offer Slip",
    href: "Placing"
  },
  {
    name: "Cover Note",
    href: "Cover"
  },
  {
    name: "Debit Note",
    href: "Debit"
  },
  {
    name: "Contract Changes",
    href: "Contract"
  },

]

export default function ViewOfferSlipContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const [orderStatus, setOrderStatus] = useState("Placing");
  const searchParams = useSearch<LocationGenerics>();
  const { loading } = useInsurer(searchParams?.id || "");

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      hidePadding
      size="6xl"
      title="Placing Slip"
      description={"Details of placing slip are shown below"}
    >
      <ModalTabs
        tabs={tabs}
        setOrderStatus={setOrderStatus}
        orderStatus={orderStatus}
      />
      {orderStatus === "Placing" && <PDFRenderer
        url={`${config.asset.uri}endorsement_placing_slip/${btoa(
          JSON.stringify({
            offer_endorsement_id: searchParams?.id,
            doc_number: -1,
            type: "Cover",
            hasEndOfferSlip: true,
          })
        )}`}
      />}
      {orderStatus === "Cover" && <PDFRenderer
        url={`${config.asset.uri}contract_changes/${btoa(
          JSON.stringify({
            offer_endorsement_id: searchParams?.id,
            type: "Cover",
            doc_number: -1,
          })
        )}`}
      />}
      {orderStatus === "Debit" && <PDFRenderer
        url={`${config.asset.uri}endorsement_debit_note/${btoa(
          JSON.stringify({
            offer_endorsement_id: searchParams?.id,
            doc_number: -1,
          })
        )}`}
      />}
      {orderStatus === "Contract" && <PDFRenderer
        url={`${config.asset.uri}contract_changes/${btoa(
          JSON.stringify({
            offer_endorsement_id: searchParams?.id,
            doc_number: -1,
            type: "Contract",
          })
        )}`}
      />}
    </Modal>
  );
}
